import { v4 as uuidv4 } from 'uuid';
export const genSiteLinkButtonHtml = (buttonData) => {
    const id = uuidv4().replaceAll('-', '');
    const className = buttonData.link ? 'sirius-site-link-button' : '';
    const html = `<a
 contenteditable="false"
 href="${buttonData.link}"
 target="_blank"
 data-id="${id}"
 data-name="${buttonData.btnName}"
 data-business-type="${buttonData.businessType}"
 data-page="${buttonData.pageId || ''}"
 class="${className}"
 style="cursor: pointer;
  margin-right: 16px;
  padding: 5px 12px;
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #4C6AFF;
  color: #4C6AFF;
  font-size: 12px;
  line-height: 1.67;
  text-decoration: none;
  max-width: 320px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;"
>
${buttonData.btnName}
</a>`;
    return html;
};
